import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PromotionManagerState {
  companyId?: string;
  artistId?: string;
  titleId?: string;
  variationId?: string;
}

const initialState: PromotionManagerState = {
  companyId: '',
  artistId: '',
  titleId: '',
  variationId: '',
};

export const promotionManagerSlice = createSlice({
  name: 'promotionManager',
  initialState,
  reducers: {
    setPromotionFilter: (
      state,
      data: PayloadAction<{
        companyId: string;
        artistId: string;
        titleId: string;
        variationId: string;
      }>,
    ) => {
      const { payload } = data;
      return { ...payload };
    },
  },
});

export const { setPromotionFilter } = promotionManagerSlice.actions;
export default promotionManagerSlice.reducer;
